import React, { useEffect, useState } from 'react'
//*Material
import Grid from '@material-ui/core/Grid'
import { makeStyles } from '@material-ui/core/styles'
import withStyles from '@material-ui/core/styles/withStyles'
import Typography from '@material-ui/core/Typography'
import Button from "@material-ui/core/Button"
import { FormControl, FormGroup, TextField } from '@material-ui/core'
import Container from '@material-ui/core/Container'
import { Checkbox } from '@material-ui/core'
import { FormControlLabel } from '@material-ui/core'
import Box from '@material-ui/core/Box'
import CircularProgress from "@material-ui/core/CircularProgress"
import Backdrop from '@material-ui/core/Backdrop'
//*antd
import Modal from 'antd/es/modal';
//*Styles and Assets
import { TelematicsStyles } from '../TelematicsStyles'
import { useTranslation } from 'react-i18next'
//*Redux
import { connect } from "react-redux"
import { useHistory } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import * as navigationActions from '../../../actions/common/NavigationActions'
import * as TelematicsActions from '../../../actions/telematics/TelematicsActions'
//*Components
import UseForm from '../../common/UseForm'
import Constants from '../../common/Constants.json'

const useStyles = makeStyles({
    cardHeader: {
        backgroundColor: "#7a9bc2",
        color: "white"
    },
    stageButton: {
        backgroundColor: "#063452",
        color: "white"
    },
    denyButton: {
        backgroundColor: "white"
    },
    pdfButton: {
        backgroundColor: "white"
    },
    appbar: {
        backgroundColor: "White",

    },
    tab: {
        backgroundColor: '#A5A5A5',
        '&.Mui-selected': {
            backgroundColor: '#789AC1'
        },
        borderTopRigthRadius: "15%",
        textTransform: "capitalize"
    },
    indicator: {
        backgroundColor: "#7a9bc2"
    },
    checked: {
        '&$checked': {
            color: "#7a9bc2"
        }
    }
})

const ServiceFinalization = ({ classes, ...props }) => {
    const { t } = useTranslation();
    const localclass = useStyles();
    const history = useHistory()
    const [openBackdrop, setOpenBackdrop] = useState(false);
    const [ended, setEnded] = useState(false)
    const [notEnded, setNotEnded] = useState(false)
    const { match: { params } } = props

    const initialFieldValues = {
        SerialNum: "",
        WorkCompleted: false,
        Comment: "",
        TypeService: ""
    }

    const {
        values,
        handleInputChange,
        resetForm
    } = UseForm(initialFieldValues)

    useEffect(() => {
        const newRoute = {
            path: '/telematics/UploadEvidence/',
            linkLegend: t('telematicsDetail.uploadEvidence'),
        }
        props.navigationActions.add_route(newRoute)
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    const handleCloseBackdrop = () => {
        setOpenBackdrop(false);
    }

    const handleOpenBackdrop = () => {
        setOpenBackdrop(true);
    }

    const onSuccessSave = (response) => {
        handleCloseBackdrop()
        if (response.success) {
            Modal.success({
                title: t('commonMessages.savedSucc')
            })
            history.push(`/telematics/InstalationDetails/${params.branchOfficeId}&${params.instalationId}&${Constants.orderDetailsTelematics.Services}`)
        } else {
            Modal.error({
                title: 'Error',
                content: response.message
            })
        }
        resetForm()
        setEnded(false)
        setNotEnded(false)
    }

    const onError = (err) => {
        handleCloseBackdrop()
        if (err.response && err.response.status) {
            switch (err.response.status) {
                case 400:
                    Modal.error({
                        title: 'Error',
                        content: t(`telematicsErrors.${err.response.data.errors.ErrorCodes[0]}`)
                    })
                    break
                case 401:
                    props.tokenExpired()
                    history.push('/login')
                    break
                case 403:
                    history.push('/forbidden')
                    break
                case 500:
                    Modal.error({
                        title: 'Error',
                        content: t('commonMessages.alert500')
                    })
                    break
                default:
                    break
            }
        }
    }

    const checkChangeEnded = () => {
        setEnded(true)
        setNotEnded(false)
    }

    const checkChangeNotEnded = () => {
        setEnded(false)
        setNotEnded(true)
    }

    const handleSubmit = e => {
        if ((ended !== false || notEnded !== false) && values.Comment !== '') {
            e.preventDefault()
            handleOpenBackdrop()

            let WorkCompleted = (ended === true) ? true : false
            const formData = {
                "SerialNum": values.SerialNum,
                "WorkCompleted": WorkCompleted,
                "Comment": values.Comment,
                "TypeService": params.typeService
            }

            props.actions.UploadWorkCompleted(props.userLanguage, props.userToken, formData, params.serviceId, onError, onSuccessSave)
        } else {
            Modal.error({
                title: 'Error',
                content: t('commonMessages.errorUndefined')
            })
        }
    }

    return (
        <div>
            <Container className={classes.generalBorder}>
                <br />
                <Backdrop className={classes.backdrop} open={openBackdrop}>
                    <CircularProgress color="inherit" />
                </Backdrop>
                <Grid container direction="row" justify="space-between" alignItems="flex-start" >
                    <Grid item xs={5}>
                        <Typography variant="body1" style={{ fontWeight: 600 }}>{t('telematicsDetail.seriesNumber')}</Typography>
                        <FormControl fullWidth >
                            <TextField
                                value={values.SerialNum}
                                name="SerialNum"
                                placeholder={t('telematicsDetail.seriesNumberInput')}
                                size="small"
                                onChange={handleInputChange}
                                fullWidth />
                        </FormControl>
                    </Grid>
                    <Grid item xs={5}>
                        <Typography variant="body1" style={{ fontWeight: 600 }}>{t('telematicsDetail.serviceStatus')}</Typography>
                        <FormGroup row={true}>
                            <FormControlLabel
                                control={<Checkbox className={localclass.checked} onChange={checkChangeEnded} checked={ended} />}
                                label={t('common.ended')}
                            />
                            <FormControlLabel
                                control={<Checkbox className={localclass.checked} onChange={checkChangeNotEnded} checked={notEnded} />}
                                label={t('common.notEnded')}
                            />
                        </FormGroup>
                    </Grid>
                </Grid>
                <br />
                <Grid container direction="row" justify="space-between" alignItems="flex-start" >
                    <Grid item xs={12}>
                        <Typography variant="body1" component={'span'}>
                            <Box fontWeight={600}>{t('common.comments')}</Box>
                        </Typography>
                        <TextField
                            label=""
                            value={values.Comment}
                            name="Comment"
                            variant="outlined"
                            onChange={handleInputChange}
                            fullWidth={true}
                            multiline
                            rows={5}
                        />
                    </Grid>
                </Grid>
                <br />
                <Grid item xs={12} className={classes.buttonAlign}>
                    <Button variant="outlined" className={classes.generalBorder} onClick={handleSubmit}>{t('common.finalize')}</Button>
                </Grid>
                <br />
            </Container>
        </div>
    )
}

const mapStateToProps = state => ({
    phoneTypeList: state.TelematicsReducer.phoneTypesList,
    userlogin: state.LoginReducer.list,
    isUserAuthenticated: state.LoginReducer.isAuthenticated,
    userToken: state.LoginReducer.token,
    userLanguage: state.LoginReducer.language
})

const mapDispatchToProps = dispatch => {
    return {
        tokenExpired: () => dispatch({ type: 'TOKEN_EXPIRED' }),
        actions: bindActionCreators(TelematicsActions, dispatch),
        navigationActions: bindActionCreators(navigationActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(TelematicsStyles)(ServiceFinalization))